import * as TYPE from '../types';
const initialState = {
  data: {},
  dataFound: false,
  error: '',
  msg: '',
};
export const addressAnnotationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.ADDRESS_ANNOTATION_FOUND:
      return {
        ...state,
        data: action.payload.data,
        dataFound: true,
        msg: '',
        error: '',
      };
    case TYPE.ADDRESS_ANNOTATION_NO_DATA_FOUND:
      return {
        ...state,
        msg: action.payload.message,
        dataFound: false,
        data: {},
      };
    case TYPE.ADDRESS_ANNOTATION_RESET_DATA:
      return {
        data: {},
        msg: '',
        dataFound: false,
        err: '',
      };
    case TYPE.ADDRESS_ANNOTATION_ERR:
      return {
        ...state,
        error: action.payload.data.data,
        dataFound: false,
        msg: '',
        data: {},
      };
    default:
      return state;
  }
};
